/*
  cart-drawer.js — winkelwagen zijbalk.

  Werkt met de Cart AJAX API en de Section Rendering API van Shopify:
  elke wijziging stuurt `sections=cart-drawer` mee en krijgt de opnieuw
  gerenderde sectie terug. Alleen de binnenkant wordt vervangen, zodat de
  zijbalk open blijft staan en niet opnieuw inschuift.

  De zijbalk staat al in de DOM bij het laden van de pagina; hier wordt hij
  alleen geopend, bijgewerkt en gesloten.
*/

function initCartDrawer() {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-cart-scrim]');

  if (!drawer || !scrim) {
    if (window.console) {
      console.warn('[El Pasha] De zijbalk staat niet in de pagina. Controleer of ' +
        "layout/theme.liquid de regel {% section 'cart-drawer' %} bevat.");
    }
    return;
  }

  /*
    Markering voor controle. Bewust een andere naam dan data-cart-drawer:
    diezelfde naam op <html> zou elke closest()-controle hieronder laten
    slagen, waardoor de teller in de kopbalk nooit meer bijwerkt.
  */
  document.documentElement.dataset.cartDrawerReady = 'ja';

  /*
    In een sectiegroep is het id dynamisch (sections--123__cart-drawer), niet
    de bestandsnaam. De Section Rendering API wil dat echte id.
  */
  var SECTION_ID = drawer.dataset.sectionId || 'cart-drawer';

  var lastFocus = null;
  var busy = false;

  /* ------------------------------------------------------------------
     Openen en sluiten
     ------------------------------------------------------------------ */

  function focusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var first = focusables()[0];
    if (first) first.focus();
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* De achtergrond mag niet bereikbaar zijn zolang de zijbalk open staat. */
  function trapFocus(event) {
    if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
    trapFocus(event);
  });

  scrim.addEventListener('click', close);

  /* ------------------------------------------------------------------
     Bijwerken
     ------------------------------------------------------------------ */

  function setBusy(state) {
    busy = state;
    drawer.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function render(sectionHtml) {
    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = parsed.querySelector('[data-cart-drawer-inner]');
    var current = drawer.querySelector('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function syncHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      if (node.closest('[data-cart-drawer]')) return;
      node.textContent = '(' + count + ')';
    });
  }

  function afterChange(data) {
    if (data.sections && data.sections[SECTION_ID]) {
      render(data.sections[SECTION_ID]);
    }
    if (typeof data.item_count === 'number') {
      syncHeaderCount(data.item_count);
    }
  }

  /* Als het antwoord geen item_count bevat (bij /cart/add.js), apart ophalen. */
  function refreshCount() {
    return fetch(route('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncHeaderCount(cart.item_count); })
      .catch(function () {});
  }

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function post(url, body) {
    setBusy(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        afterChange(data);
        return data;
      })
      .finally(function () { setBusy(false); });
  }

  function changeLine(line, quantity) {
    return post(route('cart/change.js'), {
      line: Number(line),
      quantity: Number(quantity),
      sections: SECTION_ID
    });
  }

  function addVariant(id, quantity, stil) {
    return post(route('cart/add.js'), {
      items: [{ id: Number(id), quantity: quantity || 1 }],
      sections: SECTION_ID
    }).then(function (data) {
      if (typeof data.item_count !== 'number') refreshCount();
      /*
        Bij "direct afrekenen" blijft de zijbalk dicht: die even laten opengaan
        om hem meteen weg te navigeren is een flits zonder doel.
      */
      if (!stil) open();
      return data;
    });
  }

  /* ------------------------------------------------------------------
     Klikken binnen de zijbalk — via delegatie, want de inhoud wordt
     na elke wijziging vervangen.
     ------------------------------------------------------------------ */

  drawer.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-cart-close]');
    if (closer) {
      event.preventDefault();
      close();
      return;
    }

    if (busy) return;

    var changer = event.target.closest('[data-cart-change]');
    if (changer) {
      event.preventDefault();
      changeLine(changer.dataset.cartChange, changer.dataset.cartQuantity);
      return;
    }

    var adder = event.target.closest('[data-cart-add-variant]');
    if (adder) {
      event.preventDefault();
      addVariant(adder.dataset.cartAddVariant, 1);
    }
  });

  /* ------------------------------------------------------------------
     Buiten de zijbalk: winkelwagenknoppen en de link in de kopbalk
     ------------------------------------------------------------------ */

  /*
    Safari kent event.submitter pas sinds 15.4. Zonder die kennis is niet te
    zien of iemand op "toevoegen" of op "direct afrekenen" klikte, en dat is
    precies het verschil dat hier telt. Daarom onthouden we de laatste klik.
  */
  var laatsteKnop = null;
  document.addEventListener('click', function (event) {
    var knop = event.target.closest('button[type="submit"], input[type="submit"]');
    if (knop) laatsteKnop = knop;
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-cart-add]');
    if (!form) return;

    /*
      "Direct afrekenen" heet `checkout`. Het formulier zelf kan dat niet: het
      post naar /cart/add en Shopify stuurt daarna door naar de winkelwagen.
      Dus voegen we hier toe en verwijzen we zelf naar de kassa.
    */
    var ingedrukt = event.submitter || laatsteKnop;
    var naarKassa = !!(ingedrukt && ingedrukt.name === 'checkout');

    /*
      Het formulier uitlezen met FormData en niet met querySelector. Bij
      keuzerondjes staan er meerdere velden met de naam "id" en geeft
      querySelector altijd het eerste — dus altijd de eerste variant, wat de
      bezoeker ook aanklikt. FormData geeft wat er werkelijk verstuurd zou
      worden, precies zoals zonder JavaScript.
    */
    var velden = new FormData(form);
    var gekozen = velden.get('id');
    if (!gekozen) return; // Laat het formulier normaal doorgaan.

    event.preventDefault();
    if (busy) return;

    var aantal = velden.get('quantity') || 1;

    if (!naarKassa) {
      addVariant(gekozen, aantal);
      return;
    }

    addVariant(gekozen, aantal, true).then(function (data) {
      /*
        Alleen doorlopen als het toevoegen echt lukte. Bij een uitverkochte
        maat geeft Shopify een status terug; dan blijft de bezoeker staan en
        opent de zijbalk alsnog, zodat hij ziet wat er wél in zit.
      */
      if (data && data.status) {
        open();
        return;
      }
      window.location.href = route('checkout');
    });
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cart-link]');
    if (link) {
      event.preventDefault();
      open();
      return;
    }

    /*
      Een knop zonder gekoppeld product. Die staat er bewust zolang de winkel
      nog niet is ingericht, maar dan is het wel prettig om te weten waarom
      er niets gebeurt.
    */
    var dead = event.target.closest('[data-cart-inactive]');
    if (dead && window.console) {
      console.warn('[El Pasha] Deze knop heeft nog geen product. Koppel het product ' +
        'in de theme editor bij deze kaart; daarna werkt de winkelwagen.');
    }
  });
}

/*
  Het script staat in de head met defer, dus de pagina is normaal gesproken al
  geparseerd. De controle hieronder vangt de gevallen af waarin dat niet zo is.
*/
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawer);
} else {
  initCartDrawer();
}
